module.exports = __webpack_public_path__ + "fonts/Poppins-700-1035.51cc1e1.woff2";